import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import { get_hdr_dtl_action } from "../actions/common_action/fillList_action";
import { responseError, role_id, toastError, toastSuccess } from "../utils/constants";
import { connect } from "react-redux";
import { withRouter } from "../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAwardQueryNotification_action, award_query_seenArchive_all_action, award_query_seenArchive_action } from "../actions/common_action/notification_action";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: sessionStorage.getItem("user_id"),
      role_id: sessionStorage.getItem("role_id"),
      headerNames: [],
      headerData: [],
      selectedEvent: null,
      guest: sessionStorage.getItem("AwardsUserLoginData") == null,
      activeTab: '',
      isOpenDemo: false,
      application_form_id: '', roundName: '', totalJuryCount: '', totalJuryReviewedCount: '',
      notificationList: [], showAllNotification: false,
    };
    this.logout = this.logout.bind(this);
    this.handleEventChange = this.handleEventChange.bind(this);
  }

  componentDidMount() {
    const { guest } = this.state;
    this.setState({ application_form_id: this.props.location.state != null && this.props.location.state.application_form_id })
    if (guest) {
      this.props.navigate('/login')
    } else {
      if (sessionStorage.getItem('AwardsUserLoginData') == null) {
        this.props.navigate('/login')
      } else {
        this.getHdrDtl();
      }
    }
  }
  toggleDropdown = () => {
    this.setState((prevState) => ({ isOpenDemo: !prevState.isOpenDemo }));
    // this.setState((prev) => !prev);
  };
  getHdrDtl() {
    const { user_id, role_id } = this.state;
    if (role_id == 5) {
      this.props.navigate('/cms/manage')
      return;
    }
    this.props.get_hdr_dtl_action(user_id, role_id)
      .then((data) => {
        if (data.error !== 1) {
          const array = []
          data.data[1]?.length > 0 && data.data[1].map((item) => {
            if ((this.state.application_form_id || this.props.data) == item.application_form_id) {
              array.push(item)
            }
          })
          data.data[1]?.length > 0 && data.data[1].map((item) => {
            if ((this.state.application_form_id || this.props.data) != item.application_form_id) {
              array.push(item)
            }
          })
          this.setState({
            headerData: data.data[0],
            headerNames: array,
            roundName: data.data[1]?.[0]?.round_name, totalJuryCount: data.data[1]?.[0]?.total_count, totalJuryReviewedCount: data.data[1]?.[0]?.total_reviewed_count,
            isPg: data?.data?.[2]?.[0]?.value
          }, () => {
            const storedAwardEventId = 1 || sessionStorage.getItem('award_event_id') != null ? sessionStorage.getItem('award_event_id') : false;
            console.log("data?.data?.[2]?.[0]?.value", data?.data?.[2]?.[0]?.value)
            sessionStorage.setItem('isPg', data?.data?.[2]?.[0]?.value)
            this.getQueryNotification(storedAwardEventId)
            if (!storedAwardEventId) {
              this.setNearestEvent();
              setTimeout(() => {
                this.getHdrDtl()
              }, 10);
            } else {
              const selectedEvent = this.state.headerData.find(event =>
                event.award_event_id.toString() === storedAwardEventId
              );
              this.setState({ selectedEvent });
            }
          });
        } else {
          responseError(data);
        }
      })
      .catch((e) => console.log(e));

  }
  setNearestEvent() {
    const { headerData } = this.state;
    if (headerData?.length === 0) return;

    const today = new Date();

    const nearestEvent = headerData.reduce((prev, curr) => {
      const currFromDate = new Date(curr.award_event_from_date);
      const currToDate = new Date(curr.award_event_to_date);
      const prevFromDate = new Date(prev.award_event_from_date);
      const prevToDate = new Date(prev.award_event_to_date);

      // Calculate the smallest distance from 'today' to the current and previous events' ranges
      const currClosestDate = Math.min(
        Math.abs(currFromDate - today),
        Math.abs(currToDate - today)
      );
      const prevClosestDate = Math.min(
        Math.abs(prevFromDate - today),
        Math.abs(prevToDate - today)
      );

      return currClosestDate < prevClosestDate ? curr : prev;
    });

    sessionStorage.setItem('award_event_id', nearestEvent.award_event_id ? nearestEvent.award_event_id : 1);
    this.setState({ selectedEvent: nearestEvent });
    this.getQueryNotification(nearestEvent)
  }

  getQueryNotification(award_event_id) {
    this.props.getAwardQueryNotification_action(award_event_id)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ notificationList: data.data })
        } else {
          responseError(data);
        }
      })
      .catch((e) => console.log(e));

  }
  seenArchive(question_id, seen_type, award_event_id) {
    this.props.award_query_seenArchive_action(question_id, seen_type)
      .then((data) => {
        if (data.error !== 1) {
          toastSuccess(seen_type == 1 ? 'Marked as Viewed' : 'Cleared Successfully')
          this.getQueryNotification(award_event_id)
        } else {
          responseError(data);
        }
      })
      .catch((e) => console.log(e));
  }
  seenArchiveAll(seen_type) {
    const award_event_id = sessionStorage.getItem('award_event_id');
    this.props.award_query_seenArchive_all_action(seen_type)
      .then((data) => {
        if (data.error !== 1) {
          toastSuccess(seen_type == 1 ? 'Marked All as Viewed' : 'Cleared All Successfully')
          this.getQueryNotification(award_event_id)
        } else {
          responseError(data);
        }
      })
      .catch((e) => console.log(e));
  }
  getBackgroundColor(statusId) {
    switch (statusId) {
      case 2:
        return '#F1C841'; // Yellow
      case 3:
        return 'red'; // Red
      case 4:
        return 'green'; // Green
      default:
        return 'transparent'; // No color
    }
  }
  async navigateApplicationForm(award_event_profile_id, application_form_id) {
    this.setState({ application_form_id: application_form_id })
    await this.props.navigate('/applicationForm', {
      state: { award_event_profile_id, application_form_id }
    });
    window.location.reload();
  }
  handleEventChange(eventId) {
    const selectedEvent = this.state.headerData.find(
      (event) => event.award_event_id === eventId
    );
    this.setState({ selectedEvent });
  }

  logout() {
    sessionStorage.clear();
    this.props.navigate('/login')
  }
  toggleAwards = (award_event_id) => {
    const currentAwardEventId = sessionStorage.getItem('award_event_id')||1;
    if (currentAwardEventId === award_event_id.toString()) {
      sessionStorage.removeItem('award_event_id');
      this.setState({ selectedEvent: null });
    } else {
      sessionStorage.setItem('award_event_id', award_event_id);
      const selectedEvent = this.state.headerData.find(event =>
        event.award_event_id === award_event_id
      );
      this.setState({ selectedEvent }, () => this.props.navigate('/adminDashboard'));
    }
  };

  render() {
    const { role_id, guest, selectedEvent, headerData, user_id, headerNames, roundName, totalJuryCount, totalJuryReviewedCount, notificationList, showAllNotification, isOpenDemo } = this.state;
    const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
    const name = userLoginData ? userLoginData.user_name : '';
    const EmailId = userLoginData ? userLoginData.email_address : '';
    const mobileNo = userLoginData ? userLoginData.contact_no : '';
    const initial = name ? name[0] : '';
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
        {
          // For screens up to 1024px (e.g., tablets in landscape)
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          // For smaller tablets or larger mobile devices
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          // For very small mobile devices
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false, // Optional for smaller screens
          },
        },
      ],
    };

    return (
      <>
        <header id="header" className="fixed-top">
          <marquee
            style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
            behavior="scroll"
            direction="left"
            scrollamount="5"
            onMouseOver={(e) => e.target.stop()}
            onMouseOut={(e) => e.target.start()}
          >
            <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
          </marquee>
          <div className="container-fluid d-flex align-items-center row p-0">
            <div className="col-2">
              <a className="logo mr-auto"
                onClick={() => this.props.navigate('/')}
              >
                <img src="img/logo.png" alt="Logo" className="img-fluid" />
              </a>
            </div>
            <div className={role_id == 4 ? "col-2" : "col-9"}>
              <nav className="nav-menu">
                <ul className="menu-list mt-3">
                  {/* Dropdown Section */}
                  <li className="menu-item drop-down">
                    <div className="dropdown-header">
                      <p className="mb-0 pb-0 head-drop">
                        {selectedEvent ? selectedEvent.award_event_name : "Select Event"}
                        {role_id == 1 && <i className="fa fa-chevron-down dropdown-icon ml-1" />}
                      </p>
                      <span>
                        {selectedEvent
                          ? new Date(selectedEvent.award_event_from_date).toLocaleDateString("en-US", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })
                          : ""}
                      </span>
                    </div>
                    {role_id == 1 && (
                      <ul className="dropdown-list p-0">
                        {headerData
                          .filter((data) => data.award_event_id !== selectedEvent?.award_event_id)
                          .map((event) => (
                            <li
                              key={event.award_event_id}
                              className="dropdown-item"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.toggleAwards(event.award_event_id)}
                            >
                              {event.award_event_name}
                            </li>
                          ))}
                      </ul>
                    )}
                  </li>

                  {/* Role-Based Menus */}
                  {(role_id == 1 || role_id == 3) && (
                    <>
                      <div className="mt-2 header-menu">
                        <Link to="/adminDashboard">
                          <span className={this.props.location.pathname === "/adminDashboard" ? "active-menu" : ""}>
                            Dashboard
                          </span>
                        </Link>
                      </div>
                      <div className="mt-2 header-menu">
                        <Link to="/adminApplicationList">
                          <span className={this.props.location.pathname === "/adminApplicationList" ? "active-menu" : ""}>
                            Application
                          </span>
                        </Link>
                      </div>
                      <div className="mt-2 header-menu">
                        <Link to="/applicationMatrix">
                          <span className={this.props.location.pathname === "/applicationMatrix" ? "active-menu" : ""}>
                            Matrix
                          </span>
                        </Link>
                      </div>
                      {(role_id == 1 || role_id == 3) && (
                        <div className="mt-2 header-menu">
                          <Link to="/juryBriefing">
                            <span className={this.props.location.pathname === "/juryBriefing" ? "active-menu" : ""}>
                              Jury Briefing
                            </span>
                          </Link>
                        </div>
                      )}
                      {(role_id == 1 || role_id == 5) && (
                        <div className="mt-2 header-menu">
                          <Link to="/cms/manage">
                            <span className={this.props.location.pathname === "/juryBriefing" ? "active-menu" : ""}>
                              Cms
                            </span>
                          </Link>
                        </div>
                      )}
                    </>
                  )}

                  {role_id == 2 && (
                    <>
                      <div className="mt-2 header-menu">
                        <Link to="/juryDashboard">
                          <span className={this.props.location.pathname === "/juryDashboard" ? "active-menu" : ""}>
                            Dashboard
                          </span>
                        </Link>
                      </div>
                      <div className="header-menu">
                        <Link to="/juryReview">
                          <div class={`award-card`} style={{ height: 'auto', padding: '10px', top: '-10px' }}>
                            <div class={`award-id ${this.props.location.pathname === "/juryReview" && "active-menu"}`}>{roundName}
                              {totalJuryCount ? <>
                                <span class={`award-status submitted`}>{totalJuryReviewedCount}/{totalJuryCount}</span>
                              </> : <>
                                <span class={`award-status submitted`}>0/0</span>
                              </>}
                            </div>
                          </div>
                        </Link>
                      </div>
                    </>
                  )}

                  {role_id == 4 && (
                    <div className="mt-2 header-menu">
                      <Link to="/applicantDashboard">
                        <span className={this.props.location.pathname === "/applicantDashboard" ? "active-menu" : ""}>
                          Dashboard
                        </span>
                      </Link>
                    </div>
                  )}
                </ul>
              </nav>
            </div>

            {role_id == 4 &&
              <div className="col-7">
                <style>
                  {`
                         .slider-container {
                           text-align: center;
                           margin: 20px auto;
                           padding: 0 10px; /* Add padding for mobile view */
                           max-width: 100%;
                         }
                         .button {
                           margin: 5px;
                           padding: 10px 15px;
                           background-color: #007bff;
                           color: white;
                           border: none;
                           border-radius: 5px;
                           cursor: pointer;
                           font-size: 16px;
                         }
                         .button:hover {
                           background-color: #0056b3;
                         }
                         .slick-prev:before, .slick-next:before {
                           color: black;
                         }
                         .slick-dots {
                           bottom: -30px; /* Adjust dot position */
                         }
                         @media (max-width: 768px) {
                           .button {
                             font-size: 14px;
                             padding: 8px 12px;
                           }
                           .slider-container h2 {
                             font-size: 18px;
                           }
                         }
                        `}
                </style>
                {headerNames != '' &&
                  <>
                    <div
                      style={{ margin: "0 auto" }}
                      className="Slider-width"
                    >
                      {headerNames?.length > 2 ?
                        <Slider {...settings}>
                          {headerNames?.length > 0 && headerNames?.map((data, i) => (
                            <>
                              <div class={`award-card ${(data.application_form_id == (this.state.application_form_id || this.props.data)) && "featured"}`} onClick={() => this.navigateApplicationForm(data.award_event_profile_id, data.application_form_id)}>
                                <div class="award-id">{data.application_no}
                                  <span class={`award-status ${data.status_name == 'Draft' ? "draft" : data.status_name == 'Submitted' ? 'submitted' : data.status_name == 'Rejected' ? 'rejected' : data.status_name == 'Reviewed' ? 'reviewed' : data.status_name == 'Verified' ? 'verified' : 'verified'}`}>{data.status_name}</span>
                                </div>
                                <div class="award-title">{data.award_name}</div>
                              </div>
                            </>
                          ))}
                        </Slider>
                        :
                        <>
                          <div className="awards-wrapper">
                            {headerNames?.length > 0 && headerNames?.map((data, i) => (
                              <>
                                <div class={`award-card ${(data.application_form_id == (this.state.application_form_id || this.props.data)) && "featured"}`} onClick={() => this.navigateApplicationForm(data.award_event_profile_id, data.application_form_id)}>
                                  <div class="award-id">{data.application_no}
                                    <span class={`award-status ${data.status_name == 'Draft' ? "draft" : data.status_name == 'Submitted' ? 'submitted' : data.status_name == 'Rejected' ? 'rejected' : data.status_name == 'Reviewed' ? 'reviewed' : data.status_name == 'Verified' ? 'verified' : 'verified'}`}>{data.status_name}</span>
                                  </div>
                                  <div class="award-title">{data.award_name}</div>
                                </div>
                              </>
                            ))}
                          </div>
                        </>
                      }
                    </div>
                  </>
                }
              </div>
            }
            <div className="col-1">
              {guest ? (
                <nav className="nav-menu d-none d-lg-block">
                  <ul>
                    <Link to="/login">
                      <li className={this.props?.mod?.data == 9 ? "nav-item active-menu" : "nav-item"}>
                        <a className="nav-link py-3">Login/Register</a>
                      </li>
                    </Link>
                  </ul>
                </nav>
              ) : (
                <nav className="nav-menu d-none d-lg-block float-right">
                  <ul>
                    <li >
                      {/* Icon Trigger */}
                      <div className="mt-2" onClick={this.toggleDropdown} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <img
                          src="img/feather_icons/info.svg"
                          alt="Info Icon"
                          style={{ marginRight: '8px' }}
                        />
                        <span className="fw-medium text-dark">Demo Videos</span>
                      </div>

                      {/* Dropdown Content */}
                      {isOpenDemo && (
                        <ul
                          // className="notif-out"
                          style={{
                            maxHeight: '350px',

                            backgroundColor: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                            marginTop: '10px',
                            padding: '15px',
                            position: 'absolute',
                            zIndex: 10,
                            width: 350,
                            left: -100,
                            top: 50,

                          }}
                        >
                          {role_id == 1 || role_id == 3 ? (
                            <li className="nav-item">
                              <a
                                href="demo/itme-awards-coordinator-process.mp4"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-flex align-items-center text-decoration-underline text-primary"
                                style={{ fontSize: '18px' }}
                              >
                                <img
                                  src="img/feather_icons/video.svg"
                                  alt="Video Icon"
                                  style={{ marginRight: '6px' }}
                                />
                                Coordinator Process
                              </a>
                            </li>
                          ) : role_id == 2 ? (
                            <>
                              <li className="nav-item">
                                <a
                                  href="demo/itme-awards-jury-login.mp4"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-flex align-items-center text-decoration-underline text-primary"
                                  style={{ fontSize: '18px' }}
                                >
                                  <img
                                    src="img/feather_icons/video.svg"
                                    alt="Video Icon"
                                    style={{ width: '16px', marginRight: '6px' }}
                                  />
                                  Login & Dashboard
                                </a>
                              </li>
                              <li className="nav-item mt-2 py-1">
                                <a
                                  href="demo/itme-awards-jury-review.mp4"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-flex align-items-center text-decoration-underline text-primary"
                                  style={{ fontSize: '18px' }}
                                >
                                  <img
                                    src="img/feather_icons/video.svg"
                                    alt="Video Icon"
                                    style={{ width: '16px', marginRight: '6px' }}
                                  />
                                  Review Process
                                </a>
                              </li>
                              <li className="nav-item mt-2">
                                <a
                                  href="demo/itme-awards-jury-query.mp4"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="d-flex align-items-center text-decoration-underline text-primary"
                                  style={{ fontSize: '18px' }}
                                >
                                  <img
                                    src="img/feather_icons/video.svg"
                                    alt="Video Icon"
                                    style={{ width: '16px', marginRight: '6px' }}
                                  />
                                  Query Process
                                </a>
                                <span className="text-secondary d-block mt-1 pt-2" style={{ fontSize: '14px' }}>
                                  Click the links below to watch demo videos
                                </span>
                              </li>
                            </>
                          ) : null}
                        </ul>
                      )}
                    </li>

                    {/* notification */}
                    {(role_id == 1 || role_id == 3) && (
                      <li className="drop-down profile_li">
                        {notificationList?.length > 0 && <span class="card_badge">{notificationList?.filter(data => data.is_seen == 0)?.length}</span>}
                        <img src="img/feather_icons/bell.svg" style={{ cursor: 'pointer' }} />
                        <ul className="notif-out p-2" style={{ paddingTop: "0px", maxHeight: showAllNotification ? "25rem" : "auto", overflowY: showAllNotification ? "scroll" : "visible" }}>
                          <div className="d-flex justify-content-between align-items-center border-bottom pb-1">
                            <span className="notif">Notification</span>
                            <div>
                              <button type="button" className="btn btn-outline-primary me-2 notif-btn rounded-1 " onClick={() => this.seenArchiveAll(1)}>See All</button>
                              <button type="button" className="btn btn-outline-danger notif-btn rounded-1 " onClick={() => this.seenArchiveAll(2)}>Clear All</button>
                            </div>
                          </div>
                          {notificationList?.length > 0 ?
                            (showAllNotification ? notificationList : notificationList?.slice(0, 5))?.map((data, i) => (
                              <li className={`nav-item p-n3 p-0 mt-3 p-1 rounded-1 ${data.is_seen == 0 ? 'bg-light' : ''}`} key={i}>
                                <Link
                                  to={`/adminApplicationView`}
                                  state={{
                                    award_event_id: data.award_event_id,
                                    award_event_profile_id: data.award_event_profile_id,
                                    application_form_id: data.application_form_id
                                  }}
                                  onClick={(e) => {
                                    if (window.location.hash == '#/adminApplicationView') {
                                      e.preventDefault();
                                      window.location.reload();
                                    }
                                  }}
                                  className="nav-link p-0" key={data.application_form_id}
                                >
                                  <div className="row">
                                    <div className="col-10">
                                      <span className={data.is_seen == 0 ? "text-primary notification-text" : "text-secondary notification-text"}>
                                        {data.title}
                                      </span><br />
                                      <span style={{ fontSize: '12px' }} className={data.is_seen == 0 ? "text-primary notification-text" : "text-secondary notification-text"}>
                                        {data.question_date} | {data.question_time}
                                      </span>
                                    </div>
                                    <div className="col-2 text-right d-flex">

                                      <span title="Clear" className="" onClick={() => this.seenArchive(data.question_id, 2, data.award_event_id)}>
                                        <i className="fa fa-trash-o text-danger mr-2"></i>
                                      </span>

                                      {data.is_seen == 0 && (
                                        <span title="Mark Viewed" onClick={() => this.seenArchive(data.question_id, 1, data.award_event_id)}>
                                          {/* <i className="ri-check-double-line"></i> */}
                                          <i class="fa fa-check-square-o text-success  mt-1" aria-hidden="true"></i>
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            ))
                            : <li className="nav-item p-n3">No Notifications</li>
                          }
                          {!notificationList || notificationList.length <= 5 ? null : notificationList.length > 5 ? (
                            <li className="nav-item p-n3 text-center" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', fontSize: '12px' }} onClick={() => this.setState({ showAllNotification: true })}>
                              Show More
                            </li>
                          ) : (
                            <li className="nav-item p-n3 text-center" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', fontSize: '12px' }} onClick={() => this.setState({ showAllNotification: false })}>
                              Show Less
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    {(role_id == 2) && (
                      <li className="drop-down profile_li">
                        {/* <i className="ri-notification-line" style={{ fontSize: "28px" }}></i> */}
                        {notificationList?.length > 0 && <span class="card_badge">{notificationList?.filter(data => data.is_seen == 0)?.length}</span>}
                        <img src="img/feather_icons/bell.svg" className="mt-1" style={{ cursor: 'pointer' }} />
                        <ul style={{ paddingTop: "0px", maxHeight: showAllNotification ? "25rem" : "auto", overflowY: showAllNotification ? "scroll" : "visible" }}>
                          <div className="d-flex justify-content-between align-items-center border-bottom pb-1">
                            <span className="notif">Notification</span>
                            <div>
                              <button type="button" className="btn btn-outline-primary me-2 notif-btn rounded-1 " onClick={() => this.seenArchiveAll(1)}>See All</button>
                              <button type="button" className="btn btn-outline-danger notif-btn rounded-1 " onClick={() => this.seenArchiveAll(2)}>Clear All</button>
                            </div>
                          </div>
                          {notificationList?.length > 0 ?
                            (showAllNotification ? notificationList : notificationList?.slice(0, 5))?.map((data, i) => (
                              <li className={`nav-item p-n3 p-0 mt-3 p-1 rounded-1 ${data.is_seen == 0 ? 'bg-light' : ''}`} key={i}>
                                <Link
                                  to={`/JuryReview`}
                                  state={{
                                    award_event_id: data.award_event_id,
                                    award_event_profile_id: data.award_event_profile_id,
                                    application_form_id: data.application_form_id
                                  }}
                                  onClick={(e) => {
                                    if (window.location.hash == '#/JuryReview') {
                                      e.preventDefault();
                                      window.location.reload();
                                    }
                                  }}
                                  className="nav-link p-0" key={data.application_form_id}
                                >
                                  <div className="row">
                                    <div className="col-10">
                                      <span className={data.is_seen == 0 ? "text-primary notification-text" : "text-secondary notification-text"}>
                                        {data.title}
                                      </span><br />
                                      <span style={{ fontSize: '12px' }} className={data.is_seen == 0 ? "text-primary notification-text" : "text-secondary notification-text"}>
                                        {data.question_date} | {data.question_time}
                                      </span>
                                    </div>
                                    <div className="col-2 text-right d-flex">
                                      <span title="Clear" className="" onClick={() => this.seenArchive(data.question_id, 2, data.award_event_id)}>
                                        <i className="fa fa-trash-o text-danger mr-2"></i>
                                      </span>

                                      {data.is_seen == 0 && (
                                        <span title="Mark Viewed" onClick={() => this.seenArchive(data.question_id, 1, data.award_event_id)}>
                                          {/* <i className="ri-check-double-line"></i> */}
                                          <i class="fa fa-check-square-o text-success  mt-1" aria-hidden="true"></i>
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            ))
                            : <li className="nav-item p-n3">No Notifications</li>}

                          {!notificationList || notificationList.length <= 5 ? null : notificationList.length > 5 ? (
                            <li className="nav-item p-n3 text-center" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', fontSize: '12px' }} onClick={() => this.setState({ showAllNotification: true })}>
                              Show More
                            </li>
                          ) : (
                            <li className="nav-item p-n3 text-center" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', fontSize: '12px' }} onClick={() => this.setState({ showAllNotification: false })}>
                              Show Less
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    {(role_id == 4) && (
                      <li className="drop-down profile_li">
                        {notificationList?.length > 0 && <span class="card_badge">{notificationList?.filter(data => data.is_seen == 0)?.length}</span>}
                        <img src="img/feather_icons/bell.svg" style={{ cursor: 'pointer' }} />
                        <ul style={{ paddingTop: "0px", maxHeight: showAllNotification ? "25rem" : "auto", overflowY: showAllNotification ? "scroll" : "visible" }}>
                          <div className="d-flex justify-content-between align-items-center border-bottom pb-1">
                            <span className="notif">Notification</span>
                            <div>
                              <button type="button" className="btn btn-outline-primary me-2 notif-btn rounded-1 " onClick={() => this.seenArchiveAll(1)}>See All</button>
                              <button type="button" className="btn btn-outline-danger notif-btn rounded-1 " onClick={() => this.seenArchiveAll(2)}>Clear All</button>
                            </div>
                          </div>
                          {notificationList?.length > 0 ?
                            (showAllNotification ? notificationList : notificationList?.slice(0, 5))?.map((data, i) => (
                              <li className={`nav-item p-n3 p-0 mt-3 p-1 rounded-1 ${data.is_seen == 0 ? 'bg-light' : ''}`} key={i}>
                                <Link
                                  to={`/applicationForm`}
                                  state={{
                                    award_event_id: data.award_event_id,
                                    award_event_profile_id: data.award_event_profile_id,
                                    application_form_id: data.application_form_id
                                  }}
                                  onClick={(e) => {
                                    if (window.location.hash == '#/applicationForm') {
                                      e.preventDefault();
                                      window.location.reload();
                                    }
                                  }}
                                  className="nav-link p-0" key={data.application_form_id}
                                >
                                  <div className="row">
                                    <div className="col-10">
                                      <span className={data.is_seen == 0 ? "text-primary notification-text" : "text-secondary notification-text"}>
                                        {data.title}
                                      </span><br />
                                      <span style={{ fontSize: '12px' }} className={data.is_seen == 0 ? "text-primary notification-text" : "text-secondary notification-text"}>
                                        {data.question_date} | {data.question_time}
                                      </span>
                                    </div>
                                    <div className="col-2 text-right d-flex">
                                      <span title="Clear" className="" onClick={() => this.seenArchive(data.question_id, 2, data.award_event_id)}>
                                        <i className="fa fa-trash-o text-danger mr-2"></i>
                                      </span>

                                      {data.is_seen == 0 && (
                                        <span title="Mark Viewed" onClick={() => this.seenArchive(data.question_id, 1, data.award_event_id)}>
                                          {/* <i className="ri-check-double-line"></i> */}
                                          <i class="fa fa-check-square-o text-success  mt-1" aria-hidden="true"></i>
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            ))
                            : <li className="nav-item p-n3">No Notifications</li>
                          }
                          {!notificationList || notificationList.length <= 5 ? null : notificationList.length > 5 ? (
                            <li className="nav-item p-n3 text-center" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', fontSize: '12px' }} onClick={() => this.setState({ showAllNotification: true })}>
                              Show More
                            </li>
                          ) : (
                            <li className="nav-item p-n3 text-center" style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline', fontSize: '12px' }} onClick={() => this.setState({ showAllNotification: false })}>
                              Show Less
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    {/* modules */}
                    {(role_id == 1 || role_id == 3) && (
                      <li className="drop-down profile_li">
                        {/* <i className="ri-settings-line" style={{ fontSize: "28px" }}></i> */}
                        <img src="img/feather_icons/settings.svg" style={{ cursor: 'pointer' }} />
                        <i data-feather="bell"></i>
                        <ul style={{ paddingTop: "0px" }}>
                          {role_id == 3 ? <></> : <>
                            <li className="nav-item p-n3"><Link to="/role" className="nav-link">
                              <span className={this.props.location.pathname === "/role" ? "active-menu" : ""}>
                                Role
                              </span>
                            </Link></li>
                            <li className="nav-item p-n3"><Link to="/user" className="nav-link">
                              <span className={this.props.location.pathname === "/user" ? "active-menu" : ""}>
                                User
                              </span></Link></li>
                            <li className="nav-item p-n3"><Link to="/AdminCircular" className="nav-link">
                              <span className={this.props.location.pathname === "/AdminCircular" ? "active-menu" : ""}>
                                Circular
                              </span></Link></li>
                            <li className="nav-item p-n3"><Link to="/awardEvent" className="nav-link">
                              <span className={this.props.location.pathname === "/awardEvent" ? "active-menu" : ""}>
                                Award Event
                              </span></Link></li>
                            <li className="nav-item p-n3"><Link to="/juryProfile" className="nav-link">
                              <span className={this.props.location.pathname === "/juryProfile" ? "active-menu" : ""}>
                                Jury Profile
                              </span></Link></li>
                            <li className="nav-item p-n3"><Link to="/proformaList" className="nav-link">
                              <span className={this.props.location.pathname === "/proformaList" ? "active-menu" : ""}>
                                Proforma List
                              </span></Link></li>
                            <li className="nav-item p-n3"><Link to="/taxInvoiceList" className="nav-link">
                              <span className={this.props.location.pathname === "/taxInvoiceList" ? "active-menu" : ""}>
                                Tax Invoice List
                              </span></Link></li>
                            <li className="nav-item p-n3"><Link to="/receiptList" className="nav-link">
                              <span className={this.props.location.pathname === "/receiptList" ? "active-menu" : ""}>
                                Receipt
                              </span></Link></li>

                          </>}
                          <li className="nav-item p-n3"><Link to="/applicationQuery" className="nav-link">
                            <span className={this.props.location.pathname === "/applicationQuery" ? "active-menu" : ""}>
                              Query
                            </span></Link></li>
                          <li className="nav-item p-n3"><Link to="/reportList" className="nav-link">
                            <span className={this.props.location.pathname === "/reportList" ? "active-menu" : ""}>
                              Reports
                            </span></Link></li>
                        </ul>
                      </li>
                    )}

                    {role_id == 4 && (
                      <li className="drop-down profile_li">
                        {/* <i className="ri-settings-line" style={{ fontSize: "28px" }}></i> */}
                        <img src="img/feather_icons/settings.svg" style={{ cursor: 'pointer' }} />
                        <i data-feather="bell"></i>
                        <ul style={{ paddingTop: "0px" }}>
                          <li className="nav-item p-n3"><Link to="/proformaList" className="nav-link"><span className={this.props.location.pathname === "/proformaList" ? "active-menu" : ""}>
                            Proforma List
                          </span></Link></li>
                          <li className="nav-item p-n3"><Link to="/taxInvoiceList" className="nav-link">
                            <span className={this.props.location.pathname === "/taxInvoiceList" ? "active-menu" : ""}>
                              Tax Invoice List
                            </span></Link></li>
                          <li className="nav-item p-n3"><Link to="/receiptList" className="nav-link"><span className={this.props.location.pathname === "/receiptList" ? "active-menu" : ""}>
                            Receipt
                          </span></Link></li>
                        </ul>
                      </li>
                    )}

                    {user_id && (
                      <li className="drop-down profile_li">
                        {/* <i className="ri-account-box-line" style={{ fontSize: "28px" }}></i> */}
                        <div className="user-icon ps mt-2" style={{ cursor: 'pointer' }}>{sessionStorage.getItem('user_name')
                          ?.split(" ").map((word) => word[0])
                          ?.join("").toUpperCase()}</div>
                        {/* <img src="img/feather_icons/user.svg" style={{ cursor: 'pointer' }} /> */}
                        <ul style={{ paddingTop: "0px" }}>
                          <li className="nav-item name_li"><a className="nav-link"><p className="nameClass">
                            {name}<br />
                            {EmailId}<br />
                            {mobileNo}{mobileNo != '' && mobileNo != null && <br />}
                          </p></a></li>
                          <li className="nav-item"><Link to="/profile" className="nav-link">
                            <span className={this.props.location.pathname === "/profile" ? "active-menu" : ""}>
                              My Profile
                            </span></Link></li>
                          <li className="nav-item"><Link to="/changePassword" className="nav-link">
                            <span className={this.props.location.pathname === "/changePassword" ? "active-menu" : ""}>
                              Change Password
                            </span></Link></li>
                          <li onClick={this.logout} className="nav-item">
                            <a style={{ cursor: "pointer", color: "red" }} className="nav-link">Logout</a>
                          </li>
                        </ul>
                      </li>
                    )}
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </header >
      </>
    );
  }
}

export default withRouter(
  connect(null, { get_hdr_dtl_action, getAwardQueryNotification_action, award_query_seenArchive_all_action, award_query_seenArchive_action })(Header)
);
